(() => {

  /* ======================================================
     TOAST MESSAGE
     ====================================================== */

  function showToast(message) {

    let toast =
      document.querySelector('.lm-toast');


    if (!toast) {

      toast =
        document.createElement('div');


      toast.className =
        'lm-toast';


      document.body.appendChild(
        toast
      );

    }


    toast.textContent =
      message;


    toast.classList.add(
      'show'
    );


    clearTimeout(
      window.__lmToastTimer
    );


    window.__lmToastTimer =
      setTimeout(
        () => {

          toast.classList.remove(
            'show'
          );

        },
        1800
      );

  }



  /* ======================================================
     CART COUNT
     ====================================================== */

  async function updateCartCount() {

    try {

      const response =
        await fetch(
          '/cart.js',
          {
            headers: {
              Accept:
                'application/json'
            }
          }
        );


      if (!response.ok) {
        return;
      }


      const cart =
        await response.json();


      document
        .querySelectorAll(
          '[data-lm-cart-count]'
        )
        .forEach(
          (el) => {

            el.textContent =
              cart.item_count;

          }
        );


    } catch (_) {}

  }



  /* ======================================================
     BUTTON HELPERS
     ====================================================== */

  function getButtonTextElement(button) {

    return (
      button?.querySelector(
        '.lm-add__text'
      ) || null
    );

  }



  function getButtonLabel(button) {

    if (!button) {
      return 'Add to cart';
    }


    const text =
      getButtonTextElement(
        button
      );


    return (
      text
        ? text.textContent
        : button.textContent
    ).trim();

  }



  function setButtonLabel(
    button,
    label
  ) {

    if (!button) return;


    const text =
      getButtonTextElement(
        button
      );


    if (text) {

      text.textContent =
        label;

    } else {

      button.textContent =
        label;

    }

  }



  function setButtonLoading(button) {

    if (!button) return;


    button.disabled =
      true;


    button.classList.remove(
      'is-added',
      'is-sold-out'
    );


    setButtonLabel(
      button,
      'Adding...'
    );

  }



  function setButtonAdded(button) {

    if (!button) return;


    button.disabled =
      true;


    button.classList.remove(
      'is-sold-out'
    );


    button.classList.add(
      'is-added'
    );


    setButtonLabel(
      button,
      'Added to cart'
    );

  }



  function resetButton(
    button,
    originalLabel
  ) {

    if (!button) return;


    button.classList.remove(
      'is-added'
    );


    if (
      !button.classList.contains(
        'is-sold-out'
      )
    ) {

      button.disabled =
        false;


      setButtonLabel(
        button,
        originalLabel ||
        'Add to cart'
      );

    }

  }



  /* ======================================================
     CHANGE PRODUCT CARD TO SOLD OUT
     ====================================================== */

  function markCardSoldOut(button) {

    if (!button) return;



    /* BUTTON */

    button.disabled =
      true;


    button.classList.remove(
      'is-added'
    );


    button.classList.add(
      'is-sold-out'
    );


    setButtonLabel(
      button,
      'SOLD OUT'
    );



    /* PRODUCT CARD */

    const card =
      button.closest(
        '[data-lm-product-card], .lm-product'
      );


    if (!card) {
      return;
    }


    card.classList.add(
      'is-sold-out'
    );



    /* STOCK STATUS */

    const stock =
      card.querySelector(
        '[data-lm-card-stock], .lm-card-stock'
      );


    if (stock) {

      stock.classList.remove(
        'is-low'
      );


      stock.classList.add(
        'is-sold-out'
      );


      const stockText =
        stock.querySelector(
          '[data-lm-card-stock-text]'
        ) ||
        stock.querySelector(
          'span:last-child'
        );


      if (stockText) {

        stockText.textContent =
          'Sold out';

      }

    }



    /* IMAGE BADGE */

    const image =
      card.querySelector(
        '.lm-product-image'
      );


    if (
      image &&
      !image.querySelector(
        '.lm-stock-badge--sold'
      )
    ) {

      const existingBadge =
        image.querySelector(
          '.lm-stock-badge'
        );


      if (existingBadge) {

        existingBadge.remove();

      }


      const badge =
        document.createElement(
          'span'
        );


      badge.className =
        'lm-stock-badge lm-stock-badge--sold';


      badge.textContent =
        'SOLD OUT';


      image.appendChild(
        badge
      );

    }

  }



  /* ======================================================
     DETECT SHOPIFY INVENTORY ERRORS
     ====================================================== */

  function isInventoryError(message) {

    return (
      /sold out|inventory|not enough|not available|unavailable|out of stock/i
        .test(message || '')
    );

  }



  /* ======================================================
     AJAX ADD TO CART
     ====================================================== */

  function initAddToCart() {


    document
      .querySelectorAll(
        '[data-lm-add-form]'
      )
      .forEach(
        (form) => {


          /* Prevent duplicate listeners */

          if (
            form.dataset.lmAddReady ===
            'true'
          ) {

            return;

          }


          form.dataset.lmAddReady =
            'true';



          form.addEventListener(
            'submit',
            async function (event) {


              /* IMPORTANT:
                 Never allow Shopify's
                 normal form redirect.
              */

              event.preventDefault();



              const button =
                form.querySelector(
                  '.lm-add, button[type="submit"]'
                );



              if (
                !button ||
                button.disabled
              ) {

                return;

              }



              const originalLabel =
                getButtonLabel(
                  button
                );



              setButtonLoading(
                button
              );



              try {


                const action =
                  form.action.endsWith(
                    '.js'
                  )
                    ? form.action
                    : form.action +
                      '.js';



                const response =
                  await fetch(
                    action,
                    {

                      method:
                        'POST',

                      body:
                        new FormData(
                          form
                        ),

                      headers: {

                        Accept:
                          'application/json'

                      }

                    }
                  );



                let data = {};


                try {

                  data =
                    await response.json();

                } catch (_) {}



                /* SHOPIFY ERROR */

                if (!response.ok) {

                  throw new Error(

                    data.description ||

                    data.message ||

                    'This item could not be added to cart.'

                  );

                }



                /* ==========================================
                   SUCCESS
                   ========================================== */


                setButtonAdded(
                  button
                );


                showToast(
                  'Added to cart'
                );


                await updateCartCount();



                setTimeout(
                  () => {

                    resetButton(
                      button,
                      originalLabel
                    );

                  },
                  1500
                );



              } catch (error) {


                const message =

                  error?.message ||

                  'This item could not be added to cart.';



                /* ==========================================
                   INVENTORY CHANGED / SOLD OUT
                   ========================================== */

                if (
                  isInventoryError(
                    message
                  )
                ) {


                  markCardSoldOut(
                    button
                  );


                  showToast(
                    'Sorry, this item is sold out.'
                  );


                } else {


                  /* NORMAL ERROR */

                  resetButton(
                    button,
                    originalLabel
                  );


                  showToast(
                    message
                  );


                }


                /*
                  IMPORTANT:

                  There is intentionally NO:

                  form.submit()

                  here.

                  This prevents Shopify from
                  redirecting customers to
                  another page when inventory
                  runs out.
                */

              }

            }
          );

        }
      );



    /* ====================================================
       FALLBACK DEMO PRODUCT BUTTONS
       ==================================================== */

    document
      .querySelectorAll(
        '[data-lm-demo-add]'
      )
      .forEach(
        (button) => {


          if (
            button.dataset.lmDemoReady ===
            'true'
          ) {

            return;

          }


          button.dataset.lmDemoReady =
            'true';



          button.addEventListener(
            'click',
            () => {


              const originalLabel =
                getButtonLabel(
                  button
                );


              setButtonAdded(
                button
              );


              showToast(
                'Preview item — connect your Shopify collection in Theme Editor'
              );



              setTimeout(
                () => {

                  resetButton(
                    button,
                    originalLabel
                  );

                },
                1500
              );

            }
          );

        }
      );

  }



  /* ======================================================
     PRODUCT CAROUSELS
     ====================================================== */

  function initProductCarousels() {


    document
      .querySelectorAll(
        '[data-lm-carousel]'
      )
      .forEach(
        (carousel) => {


          if (
            carousel.dataset
              .lmCarouselReady ===
            'true'
          ) {

            return;

          }


          carousel.dataset
            .lmCarouselReady =
            'true';



          const track =
            carousel.querySelector(
              '[data-lm-track]'
            );


          const previousButton =
            carousel.querySelector(
              '[data-lm-prev]'
            );


          const nextButton =
            carousel.querySelector(
              '[data-lm-next]'
            );


          if (!track) {
            return;
          }



          function getScrollAmount() {


            const card =
              track.querySelector(
                '.lm-product'
              );


            if (!card) {
              return 300;
            }



            const styles =
              window.getComputedStyle(
                track
              );


            const gap =

              parseFloat(
                styles.columnGap
              ) ||

              parseFloat(
                styles.gap
              ) ||

              14;



            return (

              card
                .getBoundingClientRect()
                .width +

              gap

            );

          }



          previousButton
            ?.addEventListener(
              'click',
              () => {


                track.scrollBy({

                  left:
                    -getScrollAmount(),

                  behavior:
                    'smooth'

                });

              }
            );



          nextButton
            ?.addEventListener(
              'click',
              () => {


                track.scrollBy({

                  left:
                    getScrollAmount(),

                  behavior:
                    'smooth'

                });

              }
            );

        }
      );

  }



  /* ======================================================
     INITIALIZE LITTLE MOMENTS
     ====================================================== */

  function initLittleMomentsTheme() {

    initAddToCart();

    initProductCarousels();

  }



  /* NORMAL PAGE LOAD */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initLittleMomentsTheme
    );

  } else {

    initLittleMomentsTheme();

  }



  /* SHOPIFY THEME EDITOR */

  document.addEventListener(
    'shopify:section:load',
    initLittleMomentsTheme
  );
})();

/* =========================================================
   JUDGE.ME CARDS CAROUSEL
   MOBILE HEADER FIX
   ========================================================= */

(function () {

  function fixJudgeMeCardsHeader() {

    const carousels =
      document.querySelectorAll(
        '.jdgm-cards-carousel'
      );

    if (!carousels.length) return;


    carousels.forEach(function (carousel) {

      /*
       * Judge.me renders the header outside/around
       * the actual carousel element.
       */
      const section =
        carousel.closest('section') ||
        carousel.parentElement?.parentElement ||
        carousel.parentElement;


      if (!section) return;


      /* Find our exact heading without depending
         on Judge.me changing class names */
      const elements =
        section.querySelectorAll(
          'h1, h2, h3, h4, p, div, span'
        );


      let heading = null;


      elements.forEach(function (element) {

        const text =
          element.textContent
            ?.trim()
            .replace(/\s+/g, ' ');


        if (
          text ===
          'Why parents keep reaching for it.'
        ) {
          heading = element;
        }

      });


      if (heading) {

        heading.style.setProperty(
          'width',
          '100%',
          'important'
        );

        heading.style.setProperty(
          'max-width',
          '360px',
          'important'
        );

        heading.style.setProperty(
          'margin-left',
          'auto',
          'important'
        );

        heading.style.setProperty(
          'margin-right',
          'auto',
          'important'
        );

        heading.style.setProperty(
          'padding-left',
          '14px',
          'important'
        );

        heading.style.setProperty(
          'padding-right',
          '14px',
          'important'
        );

        heading.style.setProperty(
          'white-space',
          'normal',
          'important'
        );

        heading.style.setProperty(
          'overflow',
          'visible',
          'important'
        );

        heading.style.setProperty(
          'text-overflow',
          'clip',
          'important'
        );

        heading.style.setProperty(
          'word-break',
          'normal',
          'important'
        );

        heading.style.setProperty(
          'overflow-wrap',
          'normal',
          'important'
        );

        heading.style.setProperty(
          'text-align',
          'center',
          'important'
        );


        if (
          window.innerWidth <= 749
        ) {

          heading.style.setProperty(
            'font-size',
            '27px',
            'important'
          );

          heading.style.setProperty(
            'line-height',
            '1.08',
            'important'
          );

          heading.style.setProperty(
            'letter-spacing',
            '-0.03em',
            'important'
          );

        }

      }

    });

  }


  /* Judge.me can render after theme JS */
  fixJudgeMeCardsHeader();


  window.addEventListener(
    'load',
    fixJudgeMeCardsHeader
  );


  window.addEventListener(
    'resize',
    fixJudgeMeCardsHeader
  );


  const observer =
    new MutationObserver(
      function () {

        fixJudgeMeCardsHeader();

      }
    );


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

})();

/* =========================================================
   JUDGE.ME CARDS CAROUSEL
   FINAL MOBILE HEADER STRUCTURE FIX
   ========================================================= */

(function () {

  const HEADER_TEXT =
    'Why parents keep reaching for it.';


  function normalizeText(element) {
    return (
      element?.textContent ||
      ''
    )
      .replace(/\s+/g, ' ')
      .trim();
  }


  function fixJudgeCardsHeader() {

    if (window.innerWidth > 749) {
      return;
    }


    const carousels =
      document.querySelectorAll(
        '.jdgm-cards-carousel'
      );


    carousels.forEach(function (carousel) {

      /*
       * Search in the Judge.me block rather than
       * relying on Judge.me's internal class names.
       */
      let root =
        carousel.parentElement;


      for (let i = 0; i < 5; i++) {

        if (!root) break;


        if (
          normalizeText(root)
            .includes(HEADER_TEXT)
        ) {
          break;
        }


        root =
          root.parentElement;

      }


      if (!root) return;



      /* ==========================================
         FIND THE EXACT HEADING
         ========================================== */

      const candidates =
        root.querySelectorAll(
          'h1, h2, h3, h4, div, span, p'
        );


      let title = null;


      for (const element of candidates) {

        if (
          normalizeText(element) ===
          HEADER_TEXT
        ) {

          title = element;
          break;

        }

      }


      if (!title) return;


      title.classList.add(
        'lm-judge-mobile-title'
      );



      /* ==========================================
         FIND SMALLEST HEADER WRAPPER
         Contains title + rating / verified row
         ========================================== */

      let header =
        title.parentElement;


      for (let i = 0; i < 5; i++) {

        if (!header) break;


        const text =
          normalizeText(header);


        const hasRating =
          /Verified/i.test(text) ||
          /\d\.\d{1,2}/.test(text) ||
          /\(\d+\)/.test(text);


        if (
          text.includes(HEADER_TEXT) &&
          hasRating
        ) {
          break;
        }


        header =
          header.parentElement;

      }


      if (!header) return;


      header.classList.add(
        'lm-judge-mobile-header'
      );



      /* ==========================================
         FIND RATING ROW
         ========================================== */

      const descendants =
        header.querySelectorAll(
          'div, span, p, a'
        );


      let rating = null;


      /*
       * Pick the smallest element that contains
       * rating/verified data but NOT our heading.
       */
      descendants.forEach(function (element) {

        if (
          element === title ||
          element.contains(title)
        ) {
          return;
        }


        const text =
          normalizeText(element);


        const looksLikeRating =
          /Verified/i.test(text) ||
          (
            /\d\.\d{1,2}/.test(text) &&
            /\(\d+\)/.test(text)
          );


        if (!looksLikeRating) {
          return;
        }


        if (
          !rating ||
          element.children.length <
          rating.children.length
        ) {
          rating = element;
        }

      });


      if (rating) {

        rating.classList.add(
          'lm-judge-mobile-rating'
        );

      }



      /* ==========================================
         FORCE JUDGE.ME ABSOLUTE ELEMENTS BACK
         INTO NORMAL DOCUMENT FLOW
         ========================================== */

      title.style.setProperty(
        'position',
        'static',
        'important'
      );


      title.style.setProperty(
        'transform',
        'none',
        'important'
      );


      title.style.setProperty(
        'white-space',
        'normal',
        'important'
      );


      if (rating) {

        rating.style.setProperty(
          'position',
          'static',
          'important'
        );


        rating.style.setProperty(
          'transform',
          'none',
          'important'
        );

      }

    });

  }



  /* Run immediately */
  fixJudgeCardsHeader();



  /* Judge.me loads asynchronously */
  window.addEventListener(
    'load',
    fixJudgeCardsHeader
  );


  window.addEventListener(
    'resize',
    fixJudgeCardsHeader
  );



  const observer =
    new MutationObserver(
      function () {

        fixJudgeCardsHeader();

      }
    );


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

})();

